export default __webpack_public_path__ + "static/media/large.b10d41cb.jpg";